<div class="main-page-wrapper" *ngIf="request">

   <section class="single-page-section grid-layout grid-entity-header">
      <div class="grid-card main-info-card">
         <div class="card-header">
            <div class="flex-row justify-space-between align-center width-full" style="gap: 0.5rem; margin-bottom: 0.5em;">
               <div class="flex-row align-center" style="gap: .5em;">
                  <i [style.color]="status().color" [attr.icon]="status().icon" [title]="status().name | trans"></i>
                  <h3 class="card-header-title" style="margin-top: 0">{{"REQUEST" | trans}}</h3>
               </div>

               <div style="display: flex; flex-direction: column; align-items: flex-end; gap: 6px;">
                  <span>{{ request | fullname : 'created_by' }}</span>
                  <span>{{request.created_at | datefmt : 'short_date' : false }}</span>
               </div>
            </div>
         </div>
         <span class="plain-card-header-title" style="font-size: 1.2em; margin: 0.5em 0;">{{request.title }}</span>
         <div class="card-body flex-row wrappable align-flex-start" style="gap: 3rem;">
            <div class="flex-column" style="gap: .5em;">
               <!-- <task-entity-info
                  [title]="{text: request.title}"
                  [properties]="{
                     'DATE': get_dates(),
                     'TEMP_STAFF_REQUEST.NUMBER_OF_WORKERS': request.number_of_workers,
                     'LOCATION': request.location_name,
                     'TEMP_STAFF_REQUEST.SHIFTS': request.shifts
                  }"
               ></task-entity-info> -->
               <span>
                  <strong>{{'DATE' | trans}}:</strong>  &nbsp;
                  <span>{{get_dates()}}</span>
               </span>
               <span>
                  <strong>{{'TEMP_STAFF_REQUEST.NUMBER_OF_WORKERS' | trans}}:</strong>&nbsp;
                  <span>{{request.number_of_workers}}</span>
               </span>
               <span>
                  <strong>{{'LOCATION' | trans}}:</strong> &nbsp;
                  <span>{{request.location_name}}</span>
               </span>
               <span class="flex-row align-flex-start" style="gap: 0.5rem;">
                  <strong>{{'TEMP_STAFF_REQUEST.SHIFTS' | trans}}:</strong>  &nbsp;
                  <span style="white-space: pre-wrap;">{{request.shifts}}</span>
               </span>
            </div>

            <div class="flex-column" style="gap: .5em;">
               <strong>{{'DESCRIPTION' | trans}}:</strong>
               <span style="white-space: pre-wrap;">{{request.description}}</span>
            </div>
         </div>
      </div>
   </section>


   <section class="single-page-section">
      <div class="card-header">
         <h3 class="card-header-title">{{'TEMP_STAFF_REQUEST.APPLICATIONS' | trans}}</h3>
      </div>
      <div class="card-body flex-column" style="gap: .5em;">
         @for (application of applications; track application.temp_staff_application_id) {
            <div class="flex-row justify-space-between align-center width-full grid-card"
               style="min-height: auto; flex: 0 0 auto;"
               [style.borderColor]="application.accepted ? 'rgb(var(--secondary))': null"
            >
               <div class="flex-column" style="gap: .5em;">
                  <div class="flex-row align-center width-full" style="gap: 0.5rem; margin-bottom: 0.5em;">
                     <h3 class="card-header-title" style="margin: 0;">{{application.first_name + ' ' + application.last_name}},</h3>
                     <span>{{application.created_at | datefmt : 'short_date' : false }}</span>
                  </div>
                  <span><strong>{{'COMMENT' | trans}}</strong>: {{application.note}}</span>
                  @if(application.hr_note) {
                     <span><strong>{{'HR_NOTE' | trans}}</strong>: {{application.hr_note}}</span>
                  }
               </div>

               @if (plans.has(application.temp_staff_application_id)) {
                  <div class="flex-col">
                  @for (plan of plans.get(application.temp_staff_application_id); track plan.temp_staff_plan_id) {
                     <div>
                        <span>{{plan.planned_start_time | datefmt : 'short_date' : false }}</span>
                        {{' '}}
                        <span>{{plan.planned_start_time | datefmt : 'time' : false }}</span>
                        -
                        <span>{{plan.planned_end_time | datefmt : 'time' : false }}</span>
                     </div>
                  }
                  </div>
               }

               @if (application.accepted) {
                  <div class="flex-column justify-flex-end align-center" style="gap: 0.5em">
                     <span class="flex-row align-center" style="gap: 0.5em">
                        <span style="
                           width: 7px;
                           height: 7px;
                           display: block;
                           background-color: rgb(var(--secondary));
                           border-radius: 100%; "></span>
                        <span class="text-success">{{'ACCEPTED' | trans}}</span>
                     </span>

                     @if (can_add_working_hours) {
                        <button class="filled round"
                           color="primary-light"
                           (click)="add_working_hours(application.temp_staff_application_id)"
                           [attr.tooltip]="'ADD_WORKING_HOURS' | trans "
                        >
                           <i icon="schedule"></i>
                        </button>
                     }

                  </div>
               }
               @if (!application.accepted && can_accept && request.accepted_count < request.number_of_workers) {
                  <button
                     color="secondary"
                     class="filled outlined"
                     style="border-radius: 6px; font-size: 1.1rem; --button-color: var(--secondary); --button-color-contrast: var(--secondary-text);"
                     (click)="accept_application(application.temp_staff_application_id)"
                     [disabled]="!can_accept"
                  ><i icon="check"></i>{{'ACCEPT' | trans}}</button>
               }
            </div>
         }

         @if (paginator.count>paginator.page_size) {
            <div class="pager flex-row justify-flex-end">
               <button (click)="change_page(-1)" class="round paginator-previous" [disabled]="paginator.page_no === 1"><i icon="chevron_left"></i></button>
               <span>{{ paginator.page_no }} / {{ max_page_no }}</span>
               <button (click)="change_page(1)" class="round paginator-next" [disabled]="paginator.page_no === max_page_no"><i icon="chevron_right"></i></button>
            </div>
         }

         @if (paginator.count == 0) {
            <span>{{'NO_APPLICATIONS' | trans}}</span>
         }

      </div>
      <!-- <div class="grid-card" style="min-height: auto;">
      </div> -->
   </section>
</div>
